import type { IssueMap, ReportMeta } from "../types";
import type { AllBite } from "../AllBitesTable";

export function ReportHeader({
  meta,
  issueMap,
  allBites,
  totalIssues,
}: {
  meta: ReportMeta;
  issueMap: IssueMap;
  allBites: AllBite[];
  totalIssues: number;
}) {
  const title =
    meta.scope === "classroom"
      ? meta.classroomName ?? `Classroom ${meta.classroomId}`
      : meta.lessonName ?? `Lesson ${meta.lessonId}`;

  const bitesWithIssues = new Set(
    Object.values(issueMap).map((b) => `${b.sessionId}|${b.sk}`),
  ).size;

  const attendedOf =
    meta.scope === "classroom"
      ? `${meta.attended} / ${meta.enrolled}`
      : `${meta.studentCount}`;

  const statPills: { label: string; value: string }[] = [
    { label: "students", value: attendedOf },
    { label: "bites", value: `${bitesWithIssues} / ${allBites.length}` },
    { label: "issues", value: String(totalIssues) },
  ];

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <h1 className="text-xl font-bold text-foreground">{title}</h1>
        <span className="text-sm text-muted-foreground">{meta.dateLabel}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {statPills.map((p) => (
          <div
            key={p.label}
            className="rounded-lg border bg-muted/40 px-3 py-1.5 flex items-baseline gap-1.5"
          >
            <span className="text-base font-semibold tabular-nums text-foreground">{p.value}</span>
            <span className="text-xs text-muted-foreground">{p.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
